import { render, staticRenderFns } from "./OperatorPaymentDebitsNewForm.vue?vue&type=template&id=5a60fee5"
import script from "./OperatorPaymentDebitsNewForm.vue?vue&type=script&lang=js"
export * from "./OperatorPaymentDebitsNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports